<template>
    <div>
        <el-form ref="form" :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item label="子ASIN：" class="query-form-item">
                <el-input style="width: 150px;" clearable v-model="query.asin" placeholder="请输入子ASIN"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="mini" icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
                <el-button type="success" size="mini" @click="exportData" :disabled="disabled">导出数据</el-button>
            </el-form-item>
            <el-form-item label="" class="query-form-item" style="float:right;margin-right:6px;">
                <el-button size="mini" @click="routerGo()" class="el-icon-back"></el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :height="tableHeight"
            :data="list"
            size="mini"
            border
            style="width: 100%">
            <el-table-column
                width="130"
                align="center"
                label="ASIN">
                <template slot-scope="scope">
                    <div v-if="scope.row.asin" style="margin-bottom: 10px;">
                        <a :href="scope.row.url" target="_blank" class="asin_a"><span style="color: #000">子：{{scope.row.asin}}</span></a>
                    </div>
                    <div v-if="scope.row.parent_asin">
                        <span>父：{{scope.row.parent_asin}}</span>
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column
                width="110"
                align="center"
                label="父asin">
                <template slot-scope="scope">
                    <span>{{scope.row.parent_asin}}</span>
                </template>
            </el-table-column> -->
            <el-table-column
                width="110"
                align="center"
                v-if="iskeyword"
                label="关键词">
                <template slot-scope="scope">
                    <span>{{scope.row.keyword}}</span>
                </template>
            </el-table-column>
            <el-table-column
                min-width="150"
                align="center"
                v-if="!iskeyword"
                label="热词榜单">
                <template slot-scope="scope">
                    <span>{{scope.row.top_selling_list}}</span>
                </template>
            </el-table-column>
            <el-table-column
                min-width="200"
                align="center"
                label="标题">
                <template slot-scope="scope">
                    <span v-if="scope.row.product_title == null" style="color: red;">未更新</span>
                    <span v-else style="color: #000">{{scope.row.product_title}}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="150"
                align="center"
                label="品牌名">
                <template slot-scope="scope">
                    <span v-if="scope.row.product_brand == null" style="color: red;">未更新</span>
                    <span v-else>{{scope.row.product_brand}}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="70"
                align="center"
                label="价格">
                <template slot-scope="scope">
                    <span v-if="scope.row.buybox_price == null" style="color: red;">未更新</span>
                    <span v-else>{{scope.row.buybox_price}}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="110"
                align="center"
                label="页面卖家">
                <template slot-scope="scope">
                    <span v-if="scope.row.buybox_seller == null" style="color: red;">未更新</span>
                    <span v-else>{{scope.row.buybox_seller}}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="110"
                align="center"
                label="卖家类型">
                <template slot-scope="scope">
                    <span v-if="scope.row.seller_type == null" style="color: red;">未更新</span>
                    <span v-else>{{scope.row.seller_type}}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="70"
                align="center"
                label="评分人数">
                <template slot-scope="scope">
                    <span v-if="scope.row.grade_num == null" style="color: red;">未更新</span>
                    <span v-else>{{scope.row.grade_num}}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="70"
                align="center"
                label="评分星级">
                <template slot-scope="scope">
                    <span v-if="scope.row.star == null" style="color: red;">未更新</span>
                    <span v-else>{{scope.row.star}}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="84"
                align="center"
                label="上架时间">
                <template slot-scope="scope">
                    <span v-if="scope.row.date_first_available == null" style="color: red;">未更新</span>
                    <span v-else>{{scope.row.date_first_available}}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="134"
                align="center"
                label="商品更新">
                <template slot-scope="scope">
                    <span v-if="scope.row.spider_time == null" style="color: red;">未更新</span>
                    <span v-else>{{scope.row.spider_time}}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="124"
                align="center"
                label="评论条数">
                <template slot-scope="scope">
                    <span v-if="scope.row.review_num == null && scope.row.this_year_review_num == null && scope.row.last_year_review_num == null && scope.row.two_year_review_num == null && scope.row.recent_year_review_num == null" style="color: red;">未更新</span>
                    <div v-else>
                        <span v-if="scope.row.review_num">评论总数：{{scope.row.review_num}}</span>
                        <br v-if="scope.row.review_num">
                        <span v-if="scope.row.this_year_review_num">今年数量：{{scope.row.this_year_review_num}}</span>
                        <br v-if="scope.row.this_year_review_num">
                        <span v-if="scope.row.last_year_review_num">去年数量：{{scope.row.last_year_review_num}}</span>
                        <br v-if="scope.row.last_year_review_num">
                        <span v-if="scope.row.two_year_review_num">前年数量：{{scope.row.two_year_review_num}}</span>
                        <br v-if="scope.row.two_year_review_num">
                        <span v-if="scope.row.recent_year_review_num">最近一年：{{scope.row.recent_year_review_num}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                width="94"
                align="center"
                label="最早评论时间">
                <template slot-scope="scope">
                    <span v-if="scope.row.first_review_time == null" style="color: red;">未更新</span>
                    <span v-else>{{scope.row.first_review_time}}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="94"
                align="center"
                label="预估创建时间">
                <template slot-scope="scope">
                    <span v-if="scope.row.estimate_create_time == null" style="color: red;">未更新</span>
                    <span v-else>{{scope.row.estimate_create_time}}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="94"
                align="center"
                label="预估创建年份">
                <template slot-scope="scope">
                    <span v-if="scope.row.estimate_create_year == null" style="color: red;">未更新</span>
                    <span v-else>{{scope.row.estimate_create_year}}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="110"
                align="center"
                label="YTD">
                <template slot-scope="scope">
                    <span v-if="scope.row.this_year_ytd == null && scope.row.last_year_ytd == null && scope.row.two_year_ytd == null" style="color: red;">未更新</span>
                    <div v-else>
                        <span v-if="scope.row.this_year_ytd">今年：{{scope.row.this_year_ytd}}</span>
                        <br v-if="scope.row.this_year_ytd">
                        <span v-if="scope.row.last_year_ytd">去年：{{scope.row.last_year_ytd}}</span>
                        <br v-if="scope.row.last_year_ytd">
                        <span v-if="scope.row.two_year_ytd">前年：{{scope.row.two_year_ytd}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                width="134"
                align="center"
                label="统计更新">
                <template slot-scope="scope">
                    <span>{{scope.row.update_time}}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            :page-size="query.limit"
            style="float: right;margin-top: 14px; margin-bottom: 10px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="query.total">
        </el-pagination>
    </div>
</template>

<script>
import * as api from "@/api/analysis/analysis";
export default {
    data() {
        return {
            tableHeight: null,
            iskeyword: true,
            list: [],
            formData: {},
            query: {
                page: 1,
                total: 0,
                limit: 20
            },
            loading: false,
            disabled: false
        };
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val;
        }
    },
    mounted() {
        if (this.$route.query.keyword) {
            this.iskeyword = true;
        } else {
            this.iskeyword = false;
        }
        this.getList();
        this.tableHeight =
            window.innerHeight - 150 - this.$refs.form.$el.offsetHeight;
        const that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight =
                        window.innerHeight -
                        150 -
                        that.$refs.form.$el.offsetHeight;
                }
            })();
        };
    },
    methods: {
        routerGo() {
            this.$router.push({
                path: "/marketAnalysis/index?page=" + this.$route.query.page
            });
        },
        //取数据
        getList() {
            this.loading = true;
            let obj = this.query;
            obj.id = this.$route.query.id;
            api.page_list(obj)
                .then(res => {
                    this.loading = false;
                    this.list = res.data.list;
                    this.query.total = res.data.total;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //导出数据
        exportData() {
            this.disabled = true;
            api.export_for_asin_list({ id: this.$route.query.id })
                .then(res => {
                    this.disabled = false;
                    if (res.code === 0) {
                        window.open(res.data, "_blank");
                    } else {
                        this.disabled = false;
                        this.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                });
        },
        //重置
        onReset() {
            this.query = {
                page: 1,
                limit: 20,
                total: 0
            };
            this.getList();
        },
        //查询
        onSubmit() {
            this.query.page = 1;
            this.getList();
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        //分页
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        }
    }
};
</script>

<style lang="scss" scoped>
.asin_a:hover {
    text-decoration: underline;
}
/deep/ ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-track-piece {
    background-color: #ffff;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:horizontal {
    width: 7px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
</style>
